import React from 'react';

/**
 * Hai tầng thông tin biến động giá cho card "Sản phẩm đã lưu" (bản web).
 *
 *  Tầng 1 — chênh lệch so với lúc bấm lưu (↓ xanh / ↑ đỏ). Ngưỡng nhiễu 0,1%.
 *  Tầng 2 — bối cảnh 90 ngày, CHỈ hiện khi số liệu tươi (`!stale && !fromCache`).
 *           Khoe "thấp nhất 90 ngày" dựa trên giá cũ là kiểu sai nguy hiểm nhất ở đây
 *           vì nó đẩy người dùng đi mua.
 *
 * Thiếu dữ liệu ⇒ KHÔNG render gì, không hiện "Chưa đủ dữ liệu".
 *
 * ⚠️ Quy ước này phải khớp bản mobile ở
 * `mobile/src/modules/trending/components/price-delta-badges.tsx`:
 * cùng ngưỡng 0,1%, cùng thứ tự ưu tiên chip (isLowest90d trước belowAvg),
 * cùng điều kiện ẩn chip. Hai codebase tách biệt nên chép quy ước, không chép code.
 */

/** Giá giảm là tin vui cho người mua ⇒ xanh. Ngược quy ước chứng khoán, đúng ngữ cảnh mua sắm. */
function getChange(savedPrice, currentPrice) {
    if (!savedPrice) return null;
    const diff = ((currentPrice - savedPrice) / savedPrice) * 100;
    if (diff < -0.1) {
        return { text: `↓ ${Math.abs(diff).toFixed(0)}%`, cls: 'bg-green-50 border-green-100 text-green-700' };
    }
    if (diff > 0.1) {
        return { text: `↑ ${diff.toFixed(0)}%`, cls: 'bg-red-50 border-red-100 text-red-600' };
    }
    return null;
}

/** Unix giây (UTC, backend đã quy đổi) → "x phút trước". */
function timeAgo(unixSeconds) {
    if (!unixSeconds) return null;
    const mins = Math.floor((Date.now() / 1000 - unixSeconds) / 60);
    if (mins < 1) return 'vừa xong';
    if (mins < 60) return `${mins} phút trước`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs} giờ trước`;
    return `${Math.floor(hrs / 24)} ngày trước`;
}

function SavedProductPriceDelta({ priceUpdate }) {
    if (!priceUpdate) return null;

    const { currentPrice, savedPrice, stale, fromCache, checkedAt } = priceUpdate;
    const change = getChange(Number(savedPrice), Number(currentPrice));

    const isFresh = !stale && !fromCache;
    let chip = null;
    if (isFresh && priceUpdate.isLowest90d) chip = '🔥 Thấp nhất 90 ngày';
    else if (isFresh && priceUpdate.belowAvg) chip = 'Thấp hơn giá trung bình';

    const age = (stale || fromCache) && checkedAt ? timeAgo(checkedAt) : null;

    if (!change && !chip && !age) return null;

    return (
        <div className="flex items-center gap-1.5 flex-wrap">
            {change && (
                <span className={`text-[10px] border font-semibold px-1.5 py-0.5 rounded-full ${change.cls}`}>
                    {change.text} so với lúc lưu
                </span>
            )}
            {chip && (
                <span className="text-[10px] bg-green-50 border border-green-100 text-green-700 font-semibold px-1.5 py-0.5 rounded-full">
                    {chip}
                </span>
            )}
            {age && <span className="text-[10px] text-content-3">Cập nhật {age}</span>}
        </div>
    );
}

export default SavedProductPriceDelta;
